import React from "react";
import { PureAppComponent } from "../../../Components/AppComponent";
import { Button, Table } from "react-bootstrap";
import { connect } from "react-redux";

import UnpActions from "../../../Stores/redux/UnPersist/Actions";
import PActions from "../../../Stores/redux/Persist/Actions";
import AppModal from "../../../Components/Models/app-modal";
import { getFullName } from "../../../Modules/utils/fullname";
import api from "../../../Services/Api/api";
import { getPhoneNumber } from "../../../Modules/utils/phoneno";
import EditAgent from "./EditAgent";
import PrintAgentReceipt from "../AccountsScreen/PrintAgentReceipt";
import ActiveAccountsOfAgent from "./ActiveAccountsOfAgent";

const SCREEN_NAME = "AGENT_DETAILS_SCREEN";

class AgentDetailsInner extends PureAppComponent {
  state = {
    loading: "agent",
    error: null,
    visibleModal: null,
    modalData: null,
    agentClosingLoader: null,
  };

  componentDidMount() {
    this.onMount();
    this.load();
  }

  async load() {
    try {
      if (!this.props.agent?._id) throw new Error("Agent not selected");

      this.setAsyncState({ loading: "agent", error: null });

      const { agents } = await api.get("v1/agent", {
        queryStr: JSON.stringify({
          where: { _id: this.props.agent?._id },
          limit: 1,
        }),
      });

      if (!agents?.[0]) throw new Error("Agent Not Found");

      this.setAsyncState({ loading: false, agent: agents[0] });
    } catch (e) {
      this.setAsyncState({ loading: false, error: e.message });
    }
  }

  onUpdateAgent() {
    this.setAsyncState({ visibleModal: null });
    this.load();
  }

  detailsRow() {
    const {
      state: { agent },
    } = this;

    return (
      <div className="detailsrow">
        <div className="column">
          <Table striped bordered hover size="sm" className="vertical-table">
            <tbody>
              <tr>
                <th>Full Name</th>
                <td>{getFullName(agent)}</td>
              </tr>
              <tr>
                <th>Address</th>
                <td className="multiline">{agent.address}</td>
              </tr>
            </tbody>
          </Table>
        </div>
        <div className="column">
          <div>
            <Table striped bordered hover size="sm">
              <tbody>
                <tr>
                  <th>Phone</th>
                  <td>{getPhoneNumber(agent).formated}</td>
                </tr>
                <tr>
                  <th>Email</th>
                  <td>{agent.email}</td>
                </tr>
              </tbody>
            </Table>
          </div>

          <div className="flex spaceBetween">
            <div />

            <div className="flex">
              <Button
                disabled={!agent?._id}
                onClick={() => {
                  this.setAsyncState({
                    visibleModal: "editAgent",
                    modalData: { agent },
                  });
                }}
              >
                Edit
              </Button>
              <div className="m-1" />
              <Button
                disabled={!agent?._id}
                onClick={() => {
                  this.setAsyncState({
                    visibleModal: "agentReceipt",
                    modalData: { agent },
                  });
                }}
              >
                Receipt
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderInner() {
    const {
      state: {
        agent,
        loading,
        error,
        visibleModal,
        modalData,
        agentClosingLoader,
      },
    } = this;

    return (
      <div className="agent-details">
        {["agent"].includes(loading) || agentClosingLoader ? (
          <center>Loading...</center>
        ) : null}
        {error ? <div className="errormsg">{error}</div> : null}

        {agent ? this.detailsRow() : null}

        {agent?._id ? <ActiveAccountsOfAgent agent={agent} /> : null}

        <EditAgent
          {...{
            key: `editAgent-${
              visibleModal === "editAgent"
                ? modalData?.agent?._id?.toString() || "new"
                : "disabled"
            }`,

            renderModal: true,
            visible: visibleModal === "editAgent",

            handleClose: () => this.setAsyncState({ visibleModal: null }),
            onSubmit: () => this.onUpdateAgent(),
            ...(modalData || {}),
          }}
        />

        <PrintAgentReceipt
          {...{
            key: `agentReceipt-${
              visibleModal === "agentReceipt"
                ? modalData?.agent?._id?.toString() || "null"
                : "disabled"
            }`,
            renderModal: true,
            visible: visibleModal === "agentReceipt",
            handleClose: () => this.setAsyncState({ visibleModal: null }),
            ...(modalData || {}),
          }}
        />
      </div>
    );
  }

  renderModal() {
    return (
      <AppModal
        {...{
          visible: this.props.visible,
          handleClose: this.props.handleClose,
          title: `Agent Details`,
          showFooter: false,
          modalProps: {
            fullscreen: "lg-down",
            size: "lg",
            scrollable: true,
          },
          enablePrinting: true,
        }}
      >
        {this.renderInner()}
      </AppModal>
    );
  }

  render() {
    const {
      props: { renderModal = false, agent },
    } = this;

    if (!agent?._id) return null;
    else if (renderModal) return this.renderModal();
    else return this.renderInner();
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({
  setScreenState: (obj, persist = false, screenName = SCREEN_NAME) =>
    persist
      ? dispatch(PActions.setPScreenState(screenName, obj))
      : dispatch(UnpActions.setVScreenState(screenName, obj)),
});

const AgentDetails = connect(
  mapStateToProps,
  mapDispatchToProps
)(AgentDetailsInner);

export default AgentDetails;
